export class ChangePasswordDto {
  userName?: string;
  emailId?: string;
  newPassword?: string;
  oldPassword?: string;
}
